
import { useState } from "react";
import { Label } from "@/components/ui/label";

interface EmojiSelectorProps {
  selectedEmoji: string;
  onSelect: (emoji: string) => void;
  emojiOptions: string[];
}

export const EmojiSelector = ({ 
  selectedEmoji, 
  onSelect, 
  emojiOptions 
}: EmojiSelectorProps) => {
  return (
    <div className="space-y-2">
      <Label>Choose an Emoji</Label>
      <div className="flex flex-wrap gap-2">
        {emojiOptions.map((emoji) => (
          <button
            key={emoji}
            type="button"
            onClick={() => onSelect(emoji)}
            className={`text-2xl p-2 rounded-lg transition-all duration-300 ${
              selectedEmoji === emoji
                ? "bg-primary/20 scale-110"
                : "hover:bg-primary/10"
            }`}
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  );
};
